export default __webpack_public_path__ + "static/group-order-dont-dark-02d6197395f952eaf714704b47917500.png";